import axios from "axios";
import {loginEvent} from "../Context/events";

let tenant = "master";

// export const baseURL = 'http://localhost:3011/api';
// Local recette: set REACT_APP_MASTER_API_URL=http://localhost:3011/api in .env.local so toggles never hit the prod master.
export const baseURL = process.env.REACT_APP_MASTER_API_URL || 'https://api.betterfly.solutions/api';
// export const baseURL = "https://devback.purplewater-74c98b1a.francecentral.azurecontainerapps.io/api"


const api = axios.create({ baseURL: baseURL, withCredentials: true });

api.interceptors.request.use((config) => {
  config.headers["x-tenant-id"] = tenant;
  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      loginEvent.emit("login", false);
    }
    return Promise.reject(error);
  }
);

export default api;
